// ============================================================================
// FILE STORAGE ENDPOINTS
// ============================================================================

import { buildEndpoint } from './base.endpoints';

const BASE_PATH = '/Files';

export const fileStorageEndpoints = {
  upload: () => buildEndpoint(`${BASE_PATH}/upload`),
  /**
   * Download URL builder — returns the relative endpoint path with the
   * supplied storage path encoded as a query parameter. Callers prepend
   * the configured API base URL before using this as an <img src=...>.
   */
  downloadUrl: (relativePath: string) =>
    `${buildEndpoint(`${BASE_PATH}/download`)}?path=${encodeURIComponent(relativePath)}`,
} as const;

export default fileStorageEndpoints;
